import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef } from "ag-grid-enterprise";
import { decimalToTime } from "../../../../../../../utils/date-time-formatter";

export const useTableData = () => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Phases",
      children: [
        {
          field: "PhaseName",
          headerName: "Name",
          flex: 2,
          maxWidth: 120,
          cellStyle: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            marginLeft: 15,
          },
        },
        {
          field: "Start",
          headerName: "Start",
          flex: 1,
          valueGetter: (params: any) => {
            if (params.data.Start) {
              return dxtToLocalServerTime(params.data.Start, "HH:mm");
            }
          },
        },
        {
          field: "End",
          headerName: "End",
          flex: 1,
          valueGetter: (params: any) => {
            if (params.data.End) {
              return dxtToLocalServerTime(params.data.End, "HH:mm");
            }
          },
        },
        {
          field: "Duration",
          headerName: "Duration",
          flex: 1,
          valueGetter: (params: any) => {
            if (params.data.Duration) {
              return decimalToTime(params.data.Duration);
            }
          },
          minWidth: 100,
        },
        {
          field: "MWH",
          headerName: "MWH",
          flex: 1,
        },
        {
          field: "InjectedCarbon",
          headerName: "Carbon Inj.",
          flex: 1,
        },
      ],
    },
  ];

  return { columns };
};
